import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["formCard", "formTitle", "formCardBody", "medNameInput", "dateInput", "chartNameInput", "groupInput",
                    "previousBalanceInput", "balanceInput", "cardInput", "cardList", "cardDiv", "saveBtn",
                    "actionModeNewMed", "actionModeEditMed", "actionModeNewChart", "actionModeEditChart", "medInput", "chartInput"]


  connect() {
    this.controllerName = `financials--books--statements--balances--save`
  }

  cancelSave() {
    this.stopRefreshing()
    this.getControllerByIdentifier("financials--books--statements--balances--index").doIndexListHtml()
  }

  saveBalance() {
    this.getControllerByIdentifier(`app--helpers--pre-modal`).openProcessModal({ message: `Em processamento, aguarde!` })
    this.send_data = { current_user: {}, balance: {} }
    this.saveBtnTarget.disabled = true

    this.stopRefreshing()

    if (this.actionMode == `edit`) {
      this.send_data.balance.id = this.current_balance.id
      this.send_data.balance.previous_balance = this.getControllerByIdentifier("app--helpers--numbers").fromCurrencyToNumber(this.previousBalanceInputTarget.value)
    } else if (this.actionMode == `new`) {
      var chartId = this.chartInputTarget.dataset.filter
      var chart = {}

      this.application.chart_accounts.forEach(element => {
        if (element.id == chartId) {
          chart = element
        }
      })

      this.send_data.balance.date_id = this.application.current_date.id
      this.send_data.balance.med_id = Number(this.medInputTarget.dataset.medId)
      this.send_data.balance.chart_id = chart.id
      this.send_data.balance.kind = chart.kind
      this.send_data.balance.balance = 0
      this.send_data.balance.previous_balance = 0
      this.send_data.balance.chart_name = chart.chart_name
      this.send_data.balance.chart_master_name = chart.master_name
      this.send_data.balance.chart_group = chart.group
      this.send_data.balance.chart_master_group = chart.master_group
      this.send_data.balance.chart_master = chart.master
      this.send_data.balance.chart_code = chart.token

    }
    
    this.send_data.current_user.current_user_id = this.application.current_user.id
    this.send_data.current_user.feature = `financial_statement_balances`

    this.requestSave()
  }

  requestSave() {

    if (this.actionMode == `new`) {
      var url = "/financials/books/statements/balances/create"
      var method = "POST"
    } else if (this.actionMode == `edit`) {
      var url = "/financials/books/statements/balances/update_previous_balance"
      var method = "PUT"
    }

    const init = { method: method, credentials: "same-origin", headers: { "X-CSRF-Token": this.application.token, 'Content-Type': 'application/json' }, body: JSON.stringify(this.send_data) }
    var controller = this

    fetch(url, init)
      .then(response => response.json())
      .then(response => {
        if (response.save) {
          // var balances = response.data.cln
          // balances.forEach(balance => {
          //   controller.application.balances.forEach((element, i) => {
          //     if (element.id == balance.id) {
          //       controller.application.balances.splice(controller.application.balances.indexOf(element), 1, balance)
          //     }
          //   })
          // })

          var balance = response.data.cln
          
          if (this.actionMode == `new`) {
            controller.application.balances[controller.application.balances.length] = balance
          } else if (this.actionMode == `edit`) {
            controller.application.balances.forEach((element, i) => {
              if (element.id == balance.id) {
                controller.application.balances.splice(controller.application.balances.indexOf(element), 1, balance)
              }
            })
          }
          
          controller.cancelSave()
        } else {
          controller.saveBtnTarget.disabled = false
        }

        controller.getControllerByIdentifier(`app--helpers--fetch-response`).finalResponse(response)
      })
      .catch(error => {
        controller.getControllerByIdentifier(`app--helpers--fetch-response`).catchError(error)
      })
  }

  doFormHtml() {
    this.stopRefreshing()

    if (this.application.permissions.financial_statement_balances.can_update) {
      var saveBtnHtml = `<button type="button" class="btn btn-primary btn-sm py-2 btn-table f-065" data-action="click->${this.controllerName}#saveBalance" data-${this.controllerName}-target="saveBtn">Salvar</button>`
    } else {
      var saveBtnHtml = ``
    }

    var html = `<div class="row">
                  <div class="col-4 offset-4">
                    <div class="card" style="width:100%;display:relative;" data-${this.controllerName}-target="formCard" data-action="resize@window->${this.controllerName}#layout">
                      <div class="card-header d-flex align-items-center card-header-table-list f-065">
                        <h6 class="card-title display-4 py-3" style="font-size:110%;margin-bottom:0px;" data-${this.controllerName}-target="formTitle"></h6>
                      </div>
                      <div class="card-body py-0 px-2" style="overflow:auto;" data-${this.controllerName}-target="formCardBody">
                        <div class="row mt-3 d-flex align-items-center">
                          <div class="col-1 text-right px-0" data-${this.controllerName}-target="actionModeNewMed">
                            <button data-action="click->${this.controllerName}#showMeds" data-channel-setter="true" data-element="medInput" data-${this.controllerName}-target="medModal" type="button" class="btn btn-sm btn-table p-0 mc-tooltip">
                              <span class="material-icons md-sm md-dark">help_center</span>
                              <span class="mc-tooltiptext mc-tooltiptext-right">Clique para ver as Meds</span>
                            </button>
                          </div>
                          <div class="col-5" data-${this.controllerName}-target="actionModeNewMed">
                            <div class="form-group">
                              <div class="floating-label floating-label-sm">
                                <label for="medForm">MedCapital</label>
                                <input readonly="readonly" class="form-control f-075 pt-1 pb-1" data-${this.controllerName}-target="medInput" type="text" placeholder="MedCapital" required>
                              </div>
                            </div>
                          </div>
                          <div class="col-6" data-${this.controllerName}-target="actionModeEditMed">
                            <div class="form-group">
                              <div class="floating-label floating-label-sm">
                                <label for="medNameForm">MedCapital</label>
                                <input aria-describedby="medNameFormHelp" class="form-control" id="medNameForm" data-${this.controllerName}-target="medNameInput" placeholder="" type="text" required>
                              </div>
                            </div>
                          </div>
                          <div class="col-6">
                            <div class="form-group">
                              <div class="floating-label floating-label-sm">
                                <label for="dateForm">Competência</label>
                                <input aria-describedby="dateFormHelp" class="form-control" id="dateForm" data-${this.controllerName}-target="dateInput" placeholder="" type="text" required>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row mt-3 d-flex align-items-center" data-${this.controllerName}-target="actionModeNewChart">
                          <div class="col-1 text-right px-0">
                            <button data-action="click->${this.controllerName}#showChartAccounts" data-element="chartInput" data-${this.controllerName}-target="chartAccountModal" type="button" class="btn btn-sm btn-table p-0 mc-tooltip">
                              <span class="material-icons md-sm md-dark">help_center</span>
                              <span class="mc-tooltiptext mc-tooltiptext-right">Clique para ver o Plano de Conta</span>
                            </button>
                          </div>
                          <div class="col-11">
                            <div class="form-group">
                              <div class="floating-label floating-label-sm">
                                <label for="nameForm">Plano de Conta</label>
                                <input readonly="readonly" class="form-control f-075 pt-0" data-${this.controllerName}-target="chartInput" type="text" placeholder="Plano de Conta" required>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row mt-3 d-flex align-items-center" data-${this.controllerName}-target="actionModeEditChart">
                          <div class="col-12">
                            <div class="form-group">
                              <div class="floating-label floating-label-sm">
                                <label for="chartNameForm">Conta</label>
                                <input aria-describedby="chartNameFormHelp" class="form-control" id="chartNameForm" data-${this.controllerName}-target="chartNameInput" placeholder="" type="text" required>
                              </div>
                            </div>
                          </div>
                          <div class="col-12">
                            <div class="form-group">
                              <div class="floating-label floating-label-sm">
                                <label for="groupForm">Grupo Conta</label>
                                <input aria-describedby="groupFormHelp" class="form-control" id="groupForm" data-${this.controllerName}-target="groupInput" placeholder="" type="text" required>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row mt-3 d-flex align-items-center">
                          <div class="col-6">
                            <div class="form-group">
                              <div class="floating-label floating-label-sm">
                                <label for="previousBalanceInputForm">Saldo Inicial</label>
                                <input aria-describedby="previousBalanceInputFormHelp" class="form-control" id="previousBalanceInputForm" data-${this.controllerName}-target="previousBalanceInput" data-action="blur->${this.controllerName}#currencyMask keypress->${this.controllerName}#currencyMask keyup->${this.controllerName}#currencyMask blur->${this.controllerName}#bindBalance keyup->${this.controllerName}#bindBalance" placeholder="" type="text" required>
                              </div>
                            </div>
                          </div>
                          <div class="col-6">
                            <div class="form-group">
                              <div class="floating-label floating-label-sm">
                                <label for="balanceInputForm">Saldo Final</label>
                                <input aria-describedby="balanceInputFormHelp" class="form-control" id="balanceInputForm" data-${this.controllerName}-target="balanceInput" placeholder="" type="text" required>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="card-footer border-top text-right py-1">
                        <button type="button" class="btn btn-secondary btn-sm py-2 btn-table f-065" data-dismiss="modal" data-action="click->${this.controllerName}#cancelSave">Fechar</button>
                        ${saveBtnHtml}
                      </div>
                    </div>
                  </div>
                </div>`

    var controller = this
    new Promise(function (resolve) {
      resolve(controller.getControllerByIdentifier("financials--books--statements--balances--dashboard").contentTarget.innerHTML = html)
    }).then(() => {
      controller.formCardTarget.style.height = ($(window).height() * 0.5) + "px"
      if (controller.actionMode == `edit`) {
        controller.formTitleTarget.innerText = `Editando Conta de Balanço`

        controller.actionModeEditMedTarget.classList.remove(`d-none`)
        controller.actionModeNewMedTargets.forEach(element => {
          element.classList.add(`d-none`)
        })
        controller.actionModeNewChartTarget.classList.add(`d-none`)
        controller.actionModeEditChartTarget.classList.remove(`d-none`)


        controller.medNameInputTarget.value = controller.current_balance.med_name
        controller.dateInputTarget.value = controller.current_balance.date_pretty
        controller.chartNameInputTarget.value = controller.current_balance.chart_name
        controller.groupInputTarget.value = controller.current_balance.group_pretty
        controller.previousBalanceInputTarget.value = controller.getControllerByIdentifier("app--helpers--numbers").currencyMask(parseInt(controller.current_balance.previous_balance * 100))
        controller.balanceInputTarget.value = controller.getControllerByIdentifier("app--helpers--numbers").currencyMask(parseInt(controller.current_balance.balance * 100))

        controller.medNameInputTarget.disabled = true
        controller.chartNameInputTarget.disabled = true
        controller.groupInputTarget.disabled = true

      } else if (controller.actionMode == `new`) {
        controller.formTitleTarget.innerText = `Nova Conta de Balanço`

        controller.dateInputTarget.value = controller.application.current_date.date_pretty
        controller.actionModeNewMedTargets.forEach(element => {
          element.classList.remove(`d-none`)
        })
        controller.actionModeEditMedTarget.classList.add(`d-none`)
        controller.actionModeNewChartTarget.classList.remove(`d-none`)
        controller.actionModeEditChartTarget.classList.add(`d-none`)

        controller.previousBalanceInputTarget.value = controller.getControllerByIdentifier("app--helpers--numbers").currencyMask(0)
        controller.balanceInputTarget.value = controller.getControllerByIdentifier("app--helpers--numbers").currencyMask(0)

        controller.previousBalanceInputTarget.disabled = true
        controller.refreshSaveBtn()
      }

      controller.dateInputTarget.disabled = true
      controller.balanceInputTarget.disabled = true

      controller.getControllerByIdentifier("app--helpers--forms").floatingLabel()
    })
  }

  bindBalance(ev) {
    var previousBalance = Number(this.getControllerByIdentifier("app--helpers--numbers").fromCurrencyToNumber(this.previousBalanceInputTarget.value))
    var balance = Number(this.current_balance.balance)
    var newBalance = previousBalance + balance

    this.balanceInputTarget.value = this.getControllerByIdentifier("app--helpers--numbers").currencyMask(parseInt(newBalance * 100))
  }

  showMeds(ev) {
    var element = ev.currentTarget.dataset.element
    var channelSetter = ev.currentTarget.dataset.channelSetter

    var html = `<div class="modal fade" data-controller="financials--books--dashboards--meds--modal" data-financials--books--dashboards--meds--modal-target="modal" id="connectionModal" tabindex="-1" role="dialog" aria-labelledby="connectionModalTitle" aria-hidden="true" data-keyboard="false" data-backdrop="static">
                  <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                    <div class="modal-content">
                      <div class="modal-body p-0" data-financials--books--dashboards--meds--modal-target="body"></div>
                    </div>
                  </div>
                </div>`

    var controller = this
    new Promise(function (resolve) {
      resolve(document.body.insertAdjacentHTML("beforeend", html))
    }).then(() => {
      controller.getControllerByIdentifier(`financials--books--dashboards--meds--modal`).controllerForm = controller
      controller.getControllerByIdentifier(`financials--books--dashboards--meds--modal`).inputElement = this.nameTarget(element)
      controller.getControllerByIdentifier(`financials--books--dashboards--meds--modal`).channelSetter = channelSetter
      controller.getControllerByIdentifier(`financials--books--dashboards--meds--modal`).open()
    })
  }

  showChartAccounts(ev) {
    var element = ev.currentTarget.dataset.element
    var modalName = `financials--books--dashboards--chart-accounts--modal`

    var html = `<div class="modal fade" data-controller="${modalName}" data-${modalName}-target="modal" id="connectionModal" tabindex="-1" role="dialog" aria-labelledby="connectionModalTitle" aria-hidden="true" data-keyboard="false" data-backdrop="static">
                  <div class="modal-dialog modal-dialog-centered modal-slg" role="document">
                    <div class="modal-content">
                      <div class="modal-body p-0" data-${modalName}-target="body"></div>
                    </div>
                  </div>
                </div>`

    var controller = this
    new Promise(function (resolve) {
      resolve(document.body.insertAdjacentHTML("beforeend", html))
    }).then(() => {
      controller.getControllerByIdentifier(modalName).controllerForm = controller
      controller.getControllerByIdentifier(modalName).inputElement = this.nameTarget(element)
      controller.getControllerByIdentifier(modalName).hasFilter = false
      controller.getControllerByIdentifier(modalName).permission = `financial_statement_balances`
      controller.getControllerByIdentifier(modalName).open()
    })
  }

  currencyMask(ev) {
    this.getControllerByIdentifier("app--helpers--numbers").changeNumberToCurrency(ev)
  }

  getControllerByIdentifier(identifier) {
    return this.application.controllers.find(controller => {
      return controller.context.identifier === identifier;
    });
  }

  nameTarget(target) {
    return this.targets.find(target)
  }

  layout() {
    var targets = ["mainCard"]
    var identifier = ""
    // this.getControllerByIdentifier("app--helpers--layout").resizeMainCard(targets, identifier)
  }

  refreshSaveBtn() {
    var controller = this
    this.refreshTimer = setInterval(function () {
      var len = 0

      if (controller.hasSaveBtnTarget) {
        if (controller.medInputTarget.value == ``) {
          len += 1
        }

        if (controller.chartInputTarget.value == ``) {
          len += 1
        }

        if (len == 0) {
          controller.saveBtnTarget.disabled = false
        } else {
          controller.saveBtnTarget.disabled = true
        }  
      } else {
        controller.stopRefreshing()      
      }
      
    }, 200);
  }

  stopRefreshing() {
    if (this.refreshTimer) {
      clearInterval(this.refreshTimer)
    }
  }

  randonNumber() {
    var number = Math.floor(Math.random() * 1000)
    return number
  }

  // new Promise(function (resolve) {
  //   resolve()
  // }).then(() => {
  // }) 

}
